export default __webpack_public_path__ + "static/media/include_10@2x.1f15b4c5.jpg";